import { render } from "./MellonWebECRSettingsTab.vue?vue&type=template&id=544ff99c"
import script from "./MellonWebECRSettingsTab.vue?vue&type=script&lang=js"
export * from "./MellonWebECRSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__